import Vue from 'vue';
import { Component } from 'vue-property-decorator';

import { FormField, OrderWithContext } from '@/models';
import { AnalyticsEventCategory, AnalyticsEventAction, AnalyticsEventLabel } from '@/services/google/google-analytics.services';
import { removeLargeNumbers } from '@/helpers';

const MAX_DELIVERY_INSTRUCTIONS_LENGTH = 200;

@Component({
  name: 'CmgCheckoutDeliveryInfo',
})
export default class CmgCheckoutDeliveryInfo extends Vue {
  get isEstimateReady(): boolean {
    return this.$appStore.state.checkout.delivery.isDeliveryEstimateReady;
  }

  get hasEstimateError(): boolean {
    const hasError = this.$appStore.state.checkout.delivery.hasEstimateError;
    if (hasError) {
      this.$services.googleAnalytics.sendCustomEvent({
        category: AnalyticsEventCategory.Delivery,
        action: AnalyticsEventAction.ErrorMessage,
        label: AnalyticsEventLabel.TimeCantDeliver,
      });
      this.$services.googleAnalytics.sendCustomEvent({
        category: AnalyticsEventCategory.Delivery,
        action: AnalyticsEventAction.ErrorMessage,
        label: AnalyticsEventLabel.EstimatedArrivalTimeError,
      });
    }
    return hasError;
  }

  get estimateErrorMessage(): string {
    return this.$appStore.state.checkout.delivery.estimateErrorMessage;
  }

  get order(): OrderWithContext | null {
    return this.$services.order.getCurrentOrder();
  }

  get formattedArrivalInfo(): string {
    const estimate = this.$appStore.state.checkout.delivery.estimate;
    if (!estimate) {
      return '';
    }

    return `${estimate.minDeliveryTime}-${estimate.maxDeliveryTime}`;
  }

  get deliveryInstructions(): FormField {
    return this.$appStore.state.checkout.delivery.instructions;
  }

  get remainingDeliveryInstructionsChars(): number {
    return MAX_DELIVERY_INSTRUCTIONS_LENGTH - this.deliveryInstructions.value.length;
  }

  get isDeliveryOnline(): boolean {
    return this.$services.utils.isDeliveryOnline();
  }

  async onRefresh(): Promise<void> {
   await this.$services.checkout.refreshDeliveryInfo();
  }

  onInputDeliveryInstructions(e: Event) {
    if (e.target) {
      const target = e.target as HTMLInputElement;
      this.deliveryInstructions.value = target.value.substr(0, MAX_DELIVERY_INSTRUCTIONS_LENGTH);
      let deliveryInstructions = removeLargeNumbers(this.deliveryInstructions.value);
      this.deliveryInstructions.value = deliveryInstructions;
      target.value = this.deliveryInstructions.value;
    }
  }
}
